import { Routes } from '@angular/router';

export const HOME_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/home-index/home-index.component').then(
            (x) => x.HomeIndexComponent
          ),
      },
      {
        path: ':activateAccount',
        loadComponent: () =>
          import('./pages/home-index/home-index.component').then(
            (x) => x.HomeIndexComponent
          ),
      },
    ],
  },
];
